import PropTypes from "prop-types";
import React from "react";
import TypographyCompo from "../../../components/Comman/TypographyCompo";

const BillingPreviewBillSummary = ({
	billData,
	index,
	isShowBillDiscountAndCD = false,
}) => {
	const outlet = billData.outletBillsAfterApplyingOffers?.outLet;
	const bill = billData.outletBillsAfterApplyingOffers;
	const header = billData.outletBillHeader;
	const hasHeader = header && Object.keys(header).length !== 0;
	const totalBeforeOffer = hasHeader
		? header.totalAmt === null
			? 0
			: header.totalAmt
		: bill?.totalAmtBeforeOffer === null || bill?.totalAmtBeforeOffer === undefined
			? 0
			: bill.totalAmtBeforeOffer;
	const discountAmount = (
		totalBeforeOffer - (bill?.totalAmt === null ? 0 : bill?.totalAmt || 0)
	).toFixed(2);

	const summaryItems = [
		{ label: "Outlet No", value: index + 1 },
		{ label: "Outlet Name", value: outlet?.firmName || "" },
		{ label: "Owner Name", value: outlet?.ownerName || "" },
		{ label: "State Name", value: outlet?.state?.name || "" },
		{ label: "Bill No", value: bill?.billNo || "" },
		{
			label: "Taxable Amount",
			value: bill ? bill.taxableAmt.toFixed(2) : "",
			isAmount: true,
		},
		{
			label: "Total Amount",
			value: bill ? bill.totalAmt.toFixed(2) : "",
			isAmount: true,
		},
		...(isShowBillDiscountAndCD
			? [
					{
						label: "Bill Discount Amt",
						value:
							bill && bill.discountOnBillAmt !== null
								? bill.discountOnBillAmt.toFixed(2)
								: "",
						isDiscount: true,
					},
					{
						label: "Item Discount Amt",
						value:
							bill && bill.itemDistcountAmt !== null
								? bill.itemDistcountAmt.toFixed(2)
								: "",
						isDiscount: true,
					},
				]
			: []),
		{
			label: "Discount Amount",
			value: discountAmount,
			isDiscount: true,
		},
	];

  return (
    <div className="billing-preview-summary">
      {summaryItems.map((item) => (
        <div className="billing-preview-detail-item" key={item.label}>
          <TypographyCompo className="billing-preview-detail-label">
            {item.label}
          </TypographyCompo>
          <TypographyCompo
            className={`billing-preview-detail-value${
              item.isAmount ? " billing-preview-detail-value--amount" : ""
            }${
              item.isDiscount ? " billing-preview-detail-value--discount" : ""
            }`}
            component="span"
          >
            {item.value}
          </TypographyCompo>
        </div>
      ))}
    </div>
  );
};

BillingPreviewBillSummary.propTypes = {
	billData: PropTypes.object.isRequired,
	index: PropTypes.number.isRequired,
	isShowBillDiscountAndCD: PropTypes.bool,
};

export default BillingPreviewBillSummary;
